export const uk = {
    'period-from-to': '{from}–{to}'
};
